import React from 'react';

export default class NotFound extends React.PureComponent {
  render () {
    return (
      <React.Fragment>
        <h1>404, oops, page doesn't exist!</h1>
      </React.Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/NotFound.js